module.exports = __webpack_public_path__ + "static/media/user-login-black.6f052472.png";